<template>
  <div>
    <progress-bar class="c-progress-header" :value="1" :max="6" label="stappen">Progress</progress-bar>
    <h1 class="c-heading-1">Laten we even kennis maken</h1>
    <p>Vul onderstaande gegevens in om van start te gaan. In het kader van de GDPR vertellen wij jou graag wat wij met jouw opgevraagde gegevens doen. Dit kan je nalezen onderaan dit registratieformulier.</p>

    <div class="c-register-form">
      <form-row>
        <input-group label="Voornaam">
          <input type="text" :id="uniqueId" v-model="firstName" slot-scope="{ uniqueId }">
        </input-group>
        <input-group label="Naam">
          <input type="text" :id="uniqueId" v-model="lastName" slot-scope="{ uniqueId }">
        </input-group>
      </form-row>
      <input-group label="Bedrijfsnaam">
        <input type="text" :id="uniqueId" v-model="company" slot-scope="{ uniqueId }">
      </input-group>
      <input-group label="Ondernemingsnummer (*)"  v-if="isIE()">
        <input type="text" :id="uniqueId" v-model="companyId" slot-scope="{ uniqueId }">
      </input-group>
      <input-group label="Ondernemingsnummer (*)" v-if="!isIE()">
          <masked-input type="text" v-model="companyId" mask="BE0111.111.111" placeholder="BE0000.000.000" />
      </input-group>
      <form-row>
        <input-group label="Postcode">
          <input type="text" :id="uniqueId" v-model="zipCode" slot-scope="{ uniqueId }">
        </input-group>
        <input-group label="Provincie">
          <select :id="uniqueId" v-model="province" slot-scope="{ uniqueId }">
            <option disabled>Kies een provincie</option>
            <option value="Antwerpen">Antwerpen</option>
            <option value="Brussel">Brussel</option>
            <option value="Henegouwen">Henegouwen</option>
            <option value="Limburg">Limburg</option>
            <option value="Luik">Luik</option>
            <option value="Luxemburg">Luxemburg</option>
            <option value="Namen">Namen</option>
            <option value="Oost-Vlaanderen">Oost-Vlaanderen</option>
            <option value="Vlaams-Brabant">Vlaams-Brabant</option>
            <option value="Waals-Brabant">Waals-Brabant</option>
            <option value="West-Vlaanderen">West-Vlaanderen</option>
          </select>
        </input-group>
      </form-row>
      <input-group label="E-mailadres">
        <input type="email" :id="uniqueId" v-model="email" slot-scope="{ uniqueId }">
      </input-group>
      <input-group label="Telefoon">
        <input type="text" :id="uniqueId" v-model="phone" slot-scope="{ uniqueId }">
      </input-group>
      <div class="c-toolbar">
        <div class="c-toolbar__right">
          <navigation-button to="organization" @click="submitRegistration" :disabled="!allFilledIn">Volgende</navigation-button>
        </div>
      </div>
      <div class="c-footer">
        <p>Jouw gegevens worden verwerkt in het kader van de uitvoering van een gesubsidieerd project, omdat deze noodzakelijk zijn voor het uitvoeren van de overeenkomst en in het kader van onze rapporteringsverplichtingen aan de Vlaamse Overheid. Indien het gaat om gevoelige gegevens worden die niet verder verwerkt dan strikt noodzakelijk voor deze twee doelstellingen. Voor andere gegevens houdt UNIZO zich vanuit het gerechtvaardigd belang om te ondernemen het recht voor deze door te geven aan onze commerciële partners en te gebruiken voor automatische verwerkingen (o.a.) profilering om je gerichte informatie en aanbiedingen te kunnen toesturen. Een meer uitgebreid overzicht van ons beleid op het vlak van gegevensverwerking en jouw rechten, vind je in <a href="https://www.unizo.be/unizo-privacyverklaring">onze privacyverklaring</a>.</p>
      </div>
    </div>
  </div>
</template>

<script>
import FormRow from '../components/FormRow.vue'
import InputGroup from '../components/InputGroup.vue'
import NavigationButton from '../components/NavigationButton.vue'
import ProgressBar from '../components/ProgressBar'
import MaskedInput from 'vue-masked-input'
export default {
  components: {
    FormRow,
    InputGroup,
    NavigationButton,
    ProgressBar,
    MaskedInput
  },
  data () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      zipCode: '',
      province: '',
      company: '',
      companyId: ''
    }
  },
  computed: {
    allFilledIn () {
      if (
        this.firstName !== '' &&
        this.lastName !== '' &&
        this.validateEmail(this.email) &&
        this.company !== '' &&
        this.companyId !== '' &&
        this.email !== '' &&
        this.phone !== '' &&
        this.zipCode !== '' &&
        this.province !== ''
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    isIE() {
      return  /*@cc_on!@*/false || !!document.documentMode;
    },
    validateEmail (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    submitRegistration () {
      this.$store.commit('updateUserDetails', {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        company: this.company,
        companyId: this.companyId,
        phone: this.phone,
        zipCode: this.zipCode,
        province: this.province
      })
      this.$store.commit('updateProgress', 'REGISTRATION_COMPLETED')
      this.$store.dispatch('updateDatabaseRecord')
    }
  }
}
</script>

<style lang="scss">
.c-register-form {
  margin-top: 3.2rem;
}
</style>
